import { render, staticRenderFns } from "./VectorStatNew.vue?vue&type=template&id=5c295628&"
import script from "./VectorStatNew.vue?vue&type=script&lang=js&"
export * from "./VectorStatNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports